import type { PropsWithChildren } from 'react'

export const PageSubtitle = ({ children }: PropsWithChildren) => {
  return (
    <h2 className="text-base text-muted-foreground font-bold">{children}</h2>
  )
}
